import React from "react";
import RegistrationForm from "../../components/RegistrationForm/RegistrationForm";


const RegisterPage = () => {
  return (
    <div>
      <RegistrationForm />
    </div>
  );
};


export default RegisterPage;
